<script setup lang="ts">
import AppButton from '~/components/AppButton.vue'
import CmsImage from '~/layers/cms/app/components/cms/CmsImage.vue'
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'

const props = defineProps<{
  cmsDataPath: (string | number)[]
}>()
const nazwa_komponentu = 'Index/DlaczegoWarto'
const component_default_values: CmsCustomComponentType = {
  id: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'text', setting_label: 'zmien id' }
}
</script>

<template>
  <CmsCustomComponent
    v-slot="{ component_values }"
    :cms-data-path="[...props.cmsDataPath]"
    :component-name="nazwa_komponentu"
    :defaults="component_default_values"
    :open-options="true"
  >
    <div
      :id="component_values?.id?.value"
      class="px-2xl py-15 flex flex-col gap-11"
    >
      <div class="">
        <span class="text-Tekst text-H2">
          <CmsText
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_1']"
          />
        </span>
      </div>
      <div class="flex flex-col gap-5 items-start">
        <span class="text-H4 text-Tekst">
          <CmsText
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_2']"
          />
        </span>
        <CmsLink
          v-slot="{ link }"
          :cms-data-path="[...props.cmsDataPath, 'component_data', 'link_1']"
        >
          <AppButton
            button-theme="Secondary"
            :href="link?.href"
            :target="link?.target"
          >
            <span class="link-text">{{ link?.link_text ?? "Lorem Ipsum" }}</span>
          </AppButton>
        </CmsLink>
      </div>
      <div class="flex flex-col xl:grid grid-cols-12 grid-rows-1 gap-16">
        <CmsCustomComponentList
          v-slot="{ component_values: componentListValues }"
          :cms-data-path="[...props.cmsDataPath, 'component_data', 'list_1']"
          :open-options="true"
          component-name="footer_links_list_4"
          class="min-w-5 min-h-5 flex flex-col gap-10 col-span-5"
        >
          <div
            v-for="(item, index) in componentListValues"
            :key="JSON.stringify(item)"
            class="flex flex-row gap-5 items-start"
          >
            <CmsImage
              :cms-data-path="[...props.cmsDataPath, 'component_data', 'list_1', 'component_data', index, 'image']"
              class="w-16 h-11.5 object-contain"
            />
            <div class="flex flex-col gap-2.5">
              <span class="text-H4 text-Tekst">
                <CmsText
                  :cms-data-path="[...props.cmsDataPath, 'component_data', 'list_1', 'component_data', index, 'text_1']"
                />
              </span>
              <span class="text-Paragraph text-Tekst">
                <CmsText
                  :cms-data-path="[...props.cmsDataPath, 'component_data', 'list_1', 'component_data', index, 'text_2']"
                />
              </span>
            </div>
          </div>
        </CmsCustomComponentList>
        <CmsImage
          :cms-data-path="[...props.cmsDataPath, 'component_data', 'img_1']"
          class="object-cover max-h-150 col-span-7 rounded-3xl"
        />
      </div>
    </div>
  </CmsCustomComponent>
</template>
